import { render, staticRenderFns } from "./ComplaintsTable.vue?vue&type=template&id=03a04e42&scoped=true&lang=pug&"
import script from "./ComplaintsTable.vue?vue&type=script&lang=ts&"
export * from "./ComplaintsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintsTable.vue?vue&type=style&index=0&id=03a04e42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a04e42",
  null
  
)

export default component.exports